var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkViolation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FF0000",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40.0001,
    cy: 39.9998,
    r: 33.3333,
    fill: "#FF0000",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 39.9999,
    cy: 40.0002,
    r: 26.6667,
    fill: "#FF0000",
    fillOpacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#FF0000",
    fillOpacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 40.0001,
    cy: 39.9998,
    r: 13.3333,
    fill: "#FF0000",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7048 49.9318C49.0006 50.159 49.1825 50.5115 49.1825 50.9352V56.6039C49.1825 56.9798 49.034 57.3303 48.7441 57.5747C48.6753 57.6329 48.6067 57.6802 48.5383 57.7188L48.538 57.7379C48.5302 58.099 48.4648 58.4536 48.3421 58.793C47.2691 61.7534 42.4905 62.4433 39.7991 62.4489C37.1036 62.4542 32.3445 61.7848 31.247 58.8346C31.116 58.4813 31.047 58.1123 31.0401 57.7371L31.0395 57.7119C30.6524 57.5041 30.3957 57.1224 30.3957 56.604V50.9354C30.3957 50.5393 30.5603 50.1731 30.8732 49.9312L30.544 34.5141L29.1139 34.8972L28.8131 34.0327C28.3902 32.8182 28.9155 32.0245 29.9798 31.6159C29.9507 31.506 29.935 31.3883 29.935 31.2638V25.5949C29.935 25.1909 30.0881 24.8744 30.3333 24.6571L30.3182 23.9503C30.3056 23.3521 30.5633 22.7153 30.8508 22.1733C30.9281 21.3516 31.5532 20.4166 31.9986 19.8396C32.4964 19.1938 33.3557 18.229 34.2686 18.086C34.7945 17.6884 35.426 17.3335 36.0769 17.3335H43.5011C44.1558 17.3335 44.7908 17.6928 45.3179 18.093C46.2154 18.2487 47.079 19.1946 47.5785 19.8322C48.0393 20.4201 48.6537 21.35 48.7264 22.1723C49.0137 22.7147 49.2726 23.3521 49.2601 23.9505L49.2447 24.6573C49.4901 24.8746 49.6428 25.1911 49.6428 25.5951V31.264C49.6428 31.3835 49.6279 31.5002 49.5982 31.6115C50.0283 31.7746 50.4206 32.0126 50.6754 32.4261C50.9667 32.8989 50.9701 33.4436 50.7915 33.9574L50.4643 34.8974L49.0344 34.5143L48.7048 49.9318Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5387 50.0146C48.8344 50.2089 49.0179 50.5337 49.0179 50.9349V56.6036C49.0179 56.9309 48.8908 57.2362 48.6387 57.449C48.5508 57.5227 48.4638 57.5768 48.3763 57.6164L48.3739 57.7341C48.3665 58.0774 48.3043 58.4144 48.1874 58.7367C47.1446 61.614 42.4076 62.2786 39.7987 62.2842C37.1855 62.2896 32.4677 61.6446 31.4011 58.7771C31.276 58.4413 31.2108 58.0902 31.2041 57.7337L31.2015 57.6082C30.8197 57.44 30.5597 57.0957 30.5597 56.6036V50.9349C30.5597 50.5735 30.7144 50.2415 31.013 50.0317C31.0219 50.0255 31.0305 50.0196 31.0392 50.0138L30.7036 34.3009L29.2187 34.6985L28.9682 33.9782C28.556 32.7941 29.1071 32.0755 30.1867 31.7155C30.1302 31.5809 30.0994 31.4296 30.0994 31.2634V25.5947C30.0994 25.21 30.2547 24.9205 30.4992 24.7328L30.4825 23.9467C30.47 23.3699 30.7315 22.7435 31.011 22.221C31.0699 21.4307 31.7045 20.4893 32.1286 19.9393C32.5964 19.3326 33.4549 18.3542 34.3332 18.2428C34.8368 17.8567 35.4536 17.4971 36.0771 17.4971H43.5013C44.128 17.4971 44.7473 17.8601 45.2517 18.2478C46.1147 18.3723 46.9784 19.3318 47.4496 19.9332C47.8902 20.495 48.5125 21.4285 48.566 22.2194C48.8459 22.7423 49.1083 23.3693 49.096 23.9467L49.0791 24.7328C49.3236 24.9205 49.4787 25.21 49.4787 25.5947V31.2636C49.4787 31.4208 49.4497 31.5727 49.3918 31.7113C49.8461 31.8636 50.2748 32.0881 50.5358 32.5115C50.8011 32.9418 50.7987 33.4362 50.6368 33.9029L50.3595 34.6987L48.8747 34.3011L48.5387 50.0146Z",
    fill: "#E9E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3727 50.1067C48.6675 50.2636 48.854 50.5576 48.854 50.935V56.6036C48.854 56.8824 48.7485 57.1418 48.5331 57.3232C48.4276 57.412 48.3222 57.4677 48.2146 57.5021L48.2097 57.7303C48.2029 58.0558 48.144 58.3749 48.0331 58.6809C47.5402 60.0412 46.1428 60.8544 44.8528 61.322C43.2796 61.8924 41.4658 62.1164 39.7983 62.12C38.1334 62.1232 36.3226 61.9077 34.7497 61.3454C33.4566 60.8828 32.0591 60.0758 31.5549 58.7195C31.4363 58.4009 31.3744 58.0687 31.3683 57.7299L31.3635 57.4949C30.9877 57.3695 30.7243 57.0675 30.7243 56.6034V50.9348C30.7243 50.6268 30.8527 50.3449 31.1076 50.1655C31.1404 50.1431 31.1728 50.1224 31.2054 50.1049L30.8633 34.0882L29.3236 34.5005L29.1232 33.9244C28.9757 33.5003 28.9274 33.0496 29.1509 32.641C29.3964 32.1919 29.8686 31.9823 30.3352 31.8406C30.3658 31.831 30.3964 31.8221 30.4277 31.8131C30.3235 31.6644 30.2638 31.4787 30.2638 31.2632V25.5947C30.2638 25.2307 30.4221 24.9716 30.6654 24.8164L30.6466 23.9432C30.6348 23.3881 30.9008 22.7703 31.1724 22.2677C31.2096 21.5136 31.8568 20.5609 32.2588 20.0396C32.6948 19.4743 33.5576 18.4763 34.397 18.4013C34.8776 18.0272 35.4814 17.6611 36.0772 17.6611H43.5015C44.0971 17.6611 44.7005 18.027 45.1805 18.4003C45.6797 18.4449 46.1539 18.8194 46.5018 19.1429C46.7911 19.4121 47.0762 19.7227 47.3202 20.0342C47.7393 20.569 48.3721 21.51 48.4045 22.2653C48.6767 22.7683 48.9437 23.3873 48.932 23.943L48.9129 24.8162C49.1562 24.9718 49.3147 25.2307 49.3147 25.5945V31.2634C49.3147 31.4622 49.2608 31.6509 49.153 31.8082C49.6374 31.9493 50.1241 32.1565 50.396 32.5977C50.6348 32.9852 50.6273 33.4295 50.4813 33.8488L50.2545 34.5007L48.7151 34.0884L48.3727 50.1067Z",
    fill: "#DDE0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2062 50.2112C48.5003 50.3253 48.6898 50.5832 48.6898 50.9355V56.6042C48.6898 56.8344 48.6053 57.0483 48.4269 57.1982C48.3064 57.3 48.1824 57.3497 48.0529 57.3738L48.0456 57.7275C48.0388 58.035 47.9834 58.3365 47.8788 58.6253C47.4038 59.9351 46.0367 60.7191 44.7967 61.1684C43.2418 61.7325 41.4459 61.9533 39.7975 61.9565C38.1523 61.9601 36.3593 61.7472 34.8048 61.1909C33.5616 60.7463 32.1941 59.9689 31.7084 58.6629C31.5965 58.3615 31.5382 58.0474 31.532 57.7271L31.5247 57.3706C31.1575 57.2907 30.8881 57.0382 30.8881 56.6042V50.9355C30.8881 50.6816 30.9907 50.449 31.2014 50.3007C31.2581 50.2615 31.3143 50.2315 31.3714 50.2094L31.0225 33.8762L29.428 34.3032L29.2777 33.871C29.146 33.4931 29.0945 33.0859 29.2944 32.7205C29.516 32.3143 29.9614 32.1262 30.3823 31.9982C30.5014 31.9618 30.6213 31.9292 30.7417 31.8978C30.5471 31.7632 30.4276 31.5468 30.4276 31.2639V25.5951C30.4276 25.2535 30.5898 25.03 30.831 24.9105L30.8103 23.9401C30.7986 23.4065 31.071 22.7947 31.3342 22.313C31.3467 21.6014 32.01 20.6306 32.3883 20.1401C32.79 19.6194 33.6655 18.5937 34.4576 18.5619C34.9145 18.2012 35.5082 17.8257 36.0768 17.8257H43.501C44.0696 17.8257 44.6633 18.2012 45.1196 18.5615C45.5958 18.5812 46.0668 18.9633 46.3898 19.2635C46.673 19.5264 46.9521 19.831 47.1909 20.1357C47.5875 20.6417 48.2339 21.5962 48.2416 22.3104C48.5055 22.7925 48.7788 23.4053 48.7677 23.9397L48.747 24.9101C48.988 25.03 49.1504 25.2533 49.1504 25.5947V31.2635C49.1504 31.5075 49.0558 31.7317 48.859 31.8815C48.8538 31.8856 48.8478 31.8898 48.8423 31.894C49.3602 32.0268 49.9624 32.2067 50.256 32.6839C50.4688 33.0286 50.4557 33.4231 50.3264 33.7951L50.1495 34.303L48.5552 33.876L48.2062 50.2112Z",
    fill: "#D5D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0393 50.3317C48.3328 50.3977 48.5256 50.6113 48.5256 50.9351V56.6038C48.5256 56.7855 48.4622 56.9537 48.3213 57.0724C48.1896 57.1836 48.0437 57.2184 47.8922 57.2285L47.8813 57.7235C47.8753 58.0132 47.8228 58.2967 47.7244 58.5689C47.2683 59.8274 45.9305 60.5823 44.7408 61.0138C43.2041 61.5713 41.4261 61.7884 39.7974 61.7917C38.1712 61.7953 36.3966 61.5856 34.8599 61.0358C33.667 60.6092 32.3292 59.8604 31.8624 58.6049C31.757 58.3214 31.7017 58.0252 31.6964 57.7229L31.6856 57.2287C31.3313 57.1969 31.052 57.0058 31.052 56.6034V50.9347C31.052 50.7343 31.1289 50.5514 31.2959 50.4341C31.3747 50.379 31.4552 50.3478 31.5385 50.3305L31.1824 33.6627L29.5332 34.1047L29.4328 33.8166C29.1026 32.868 29.5553 32.4207 30.4301 32.1549C30.6667 32.0829 30.9073 32.0254 31.146 31.9604L31.1443 31.8793C30.8192 31.8296 30.5917 31.6191 30.5917 31.2634V25.5949C30.5917 25.278 30.7609 25.0977 30.9977 25.0181L30.9745 23.9366C30.9637 23.4238 31.2447 22.8148 31.4985 22.3556C31.4808 21.6955 32.1654 20.6982 32.5183 20.2404C32.8833 19.7676 33.7824 18.7037 34.516 18.7256C34.9474 18.3794 35.5353 17.9897 36.0771 17.9897H43.5013C44.0435 17.9897 44.6316 18.38 45.062 18.7256C45.509 18.714 45.9832 19.1095 46.2784 19.3839C46.5552 19.6413 46.8287 19.9391 47.0619 20.2374C47.4329 20.711 48.0982 21.6891 48.0777 22.3528C48.3322 22.8125 48.6145 23.423 48.6038 23.9368L48.5805 25.0183C48.8171 25.0979 48.9865 25.2784 48.9865 25.5951V31.264C48.9865 31.4564 48.9155 31.6328 48.7594 31.7513C48.6553 31.8306 48.5469 31.865 48.4336 31.8797L48.432 31.9596C48.5326 31.9857 48.6334 32.0103 48.734 32.0358C49.2149 32.1579 49.8388 32.3197 50.1162 32.77C50.3023 33.0718 50.284 33.417 50.1712 33.7412L50.0444 34.1051L48.3954 33.6631L48.0393 50.3317Z",
    fill: "#CDCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.872 50.4747C47.8973 50.4759 47.9225 50.4783 47.9484 50.4821C48.1991 50.5175 48.3613 50.6696 48.3613 50.9352V56.6038C48.3613 56.7367 48.319 56.8597 48.2156 56.9468C48.0798 57.0613 47.9029 57.0711 47.7311 57.0691L47.7174 57.7202C47.7116 57.9916 47.6627 58.258 47.5702 58.5131C47.1326 59.7199 45.8236 60.4466 44.6846 60.8597C43.1658 61.4103 41.4063 61.6246 39.7969 61.6276C38.1902 61.6311 36.4337 61.4248 34.9153 60.8818C33.7725 60.4728 32.4639 59.7521 32.0162 58.5481C31.917 58.2817 31.8655 58.0037 31.8603 57.7202L31.8462 57.0695C31.8172 57.0703 31.7877 57.0703 31.7581 57.0691C31.4629 57.0593 31.2161 56.9391 31.2161 56.6038V50.9352C31.2161 50.7884 31.2674 50.6552 31.3905 50.569C31.4865 50.5014 31.5947 50.4813 31.7056 50.4749L31.3418 33.4506L29.6381 33.9069L29.5878 33.7627C29.2902 32.9076 29.6936 32.5506 30.4781 32.312C30.7543 32.2277 31.0356 32.1635 31.3128 32.0847L31.305 31.7271C31.2758 31.7267 31.246 31.7255 31.2161 31.7227C30.9465 31.6978 30.7561 31.5533 30.7561 31.2634V25.5949C30.7561 25.3059 30.9356 25.1816 31.1648 25.1448L31.1388 23.9328C31.1281 23.44 31.4213 22.829 31.6649 22.3942C31.6092 21.7971 32.3214 20.7649 32.6486 20.3408C32.9733 19.9195 33.9125 18.8024 34.569 18.8942C34.9712 18.5652 35.5607 18.1538 36.077 18.1538H43.5012C44.0182 18.1538 44.6083 18.5666 45.0097 18.8944C45.6473 18.8159 46.5994 19.9129 46.9328 20.3386C47.2784 20.7794 47.9681 21.7878 47.9112 22.3908C48.1552 22.8258 48.4502 23.439 48.4395 23.933L48.4136 25.145C48.6425 25.1818 48.8222 25.3065 48.8222 25.5951V31.264C48.8222 31.4048 48.7749 31.5336 48.6605 31.6205C48.545 31.7084 48.4098 31.7247 48.2733 31.7271L48.2657 32.0849C48.4077 32.1243 48.5514 32.1589 48.6941 32.1951C49.1224 32.3038 49.7294 32.4551 49.9769 32.8565C50.1362 33.1148 50.1127 33.4112 50.0167 33.6876L49.9399 33.9073L48.2363 33.451L47.872 50.4747Z",
    fill: "#C5C5C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7045 50.6362C47.8693 50.6362 48.1973 50.6097 48.1973 50.9348V56.6035C48.1973 56.9604 47.7959 56.9021 47.5709 56.9021L47.5532 57.7165C47.4468 62.6921 32.1168 62.7328 32.0245 57.7165L32.007 56.9021C31.7818 56.9021 31.3804 56.9604 31.3804 56.6035V50.9348C31.3804 50.6097 31.7082 50.6362 31.8732 50.6362L31.5017 33.2375L29.7431 33.7085C29.4878 32.9757 29.7912 32.6923 30.5261 32.4687C30.8418 32.3727 31.1633 32.3023 31.4796 32.2068L31.4657 31.5621C31.283 31.5621 30.9199 31.6044 30.9199 31.2635V25.5946C30.9199 25.3232 31.1535 25.2962 31.3321 25.2962L31.303 23.9289C31.2939 23.5195 31.5261 22.9694 31.8371 22.4228L31.8353 22.4258C31.6685 21.6049 33.8091 18.7938 34.611 19.072L34.6052 19.0766C35.1162 18.6491 35.6512 18.3179 36.077 18.3179H43.5013C43.9255 18.3179 44.4574 18.6463 44.9665 19.0712C45.4982 18.8909 46.535 20.0967 46.8032 20.4392C47.0915 20.8073 47.8466 21.8848 47.7408 22.423C48.0518 22.9696 48.2838 23.5203 48.2753 23.9291L48.246 25.2964C48.4248 25.2964 48.658 25.3236 48.658 25.5948V31.2636C48.658 31.6046 48.2953 31.5623 48.1122 31.5623L48.0985 32.207C48.9709 32.4705 50.2346 32.5605 49.8616 33.6332L49.835 33.7089L48.0764 33.2379L47.7045 50.6362Z",
    fill: "#BBBDBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3056 55.6489V49.9799C46.3056 49.8156 46.4396 49.6816 46.6038 49.6816H47.1981C47.3623 49.6816 47.4965 49.8156 47.4965 49.9799V55.6489C47.4965 55.8132 47.3623 55.9472 47.1981 55.9472H46.6038C46.4396 55.9472 46.3056 55.8132 46.3056 55.6489ZM30.6799 55.6489V49.9799C30.6799 49.8156 30.8137 49.6816 30.9782 49.6816H31.5724C31.7366 49.6816 31.8708 49.8156 31.8708 49.9799V55.6489C31.8708 55.8132 31.7366 55.9472 31.5724 55.9472H30.9782C30.8135 55.9472 30.6799 55.8132 30.6799 55.6489Z",
    fill: "#414142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4138 55.6495V49.9804C46.4138 49.876 46.4993 49.7905 46.6039 49.7905H47.1982C47.3027 49.7905 47.3886 49.876 47.3886 49.9804V55.6495C47.3886 55.7539 47.3027 55.8393 47.1982 55.8393H46.6039C46.4993 55.8393 46.4138 55.7539 46.4138 55.6495Z",
    fill: "url(#paint0_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7883 55.6504V49.9814C30.7883 49.877 30.8738 49.7915 30.9784 49.7915H31.5727C31.6772 49.7915 31.7625 49.877 31.7625 49.9814V55.6504C31.7625 55.7548 31.6772 55.8403 31.5727 55.8403H30.9784C30.8736 55.8403 30.7883 55.7548 30.7883 55.6504Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7659 30.3086V24.6397C46.7659 24.4755 46.9001 24.3413 47.0644 24.3413H47.6586C47.8227 24.3413 47.9571 24.4755 47.9571 24.6397V30.3086C47.9571 30.473 47.8227 30.607 47.6586 30.607H47.0644C46.9001 30.6068 46.7659 30.473 46.7659 30.3086ZM30.219 30.3086V24.6397C30.219 24.4755 30.3532 24.3413 30.5176 24.3413H31.1119C31.2761 24.3413 31.4101 24.4755 31.4101 24.6397V30.3086C31.4101 30.473 31.2761 30.607 31.1119 30.607H30.5176C30.3532 30.6068 30.219 30.473 30.219 30.3086Z",
    fill: "#414142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8743 30.3088V24.64C46.8743 24.5354 46.9598 24.4497 47.0643 24.4497H47.6586C47.763 24.4497 47.8487 24.5354 47.8487 24.64V30.3088C47.8487 30.4134 47.763 30.4989 47.6586 30.4989H47.0643C46.9596 30.4989 46.8743 30.4134 46.8743 30.3088Z",
    fill: "url(#paint2_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3274 30.3093V24.6405C30.3274 24.5359 30.4131 24.4502 30.5177 24.4502H31.1119C31.2163 24.4502 31.3018 24.5359 31.3018 24.6405V30.3093C31.3018 30.4139 31.2163 30.4994 31.1119 30.4994H30.5177C30.4131 30.4994 30.3274 30.4139 30.3274 30.3093Z",
    fill: "url(#paint3_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.103 19.4842C45.7974 19.0944 45.423 18.6866 45.0232 18.3919C44.8518 18.2651 44.5051 18.0331 44.2639 18.117C44.8999 18.6474 45.5002 19.3284 45.8111 19.7075C46.1284 20.0938 46.6471 20.7793 47.0396 21.4706C47.1488 20.9338 46.3915 19.8527 46.103 19.4842Z",
    fill: "#FFCB0A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.017 19.551C45.3873 18.7474 44.7036 18.1998 44.3704 18.2076C44.966 18.7229 45.5175 19.3496 45.8108 19.7077C46.1011 20.0612 46.5601 20.6652 46.9367 21.2946C46.8979 20.9091 46.552 20.2335 46.017 19.551Z",
    fill: "#FEFAD6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0712 19.4842C32.3767 19.0944 32.7511 18.6866 33.1507 18.3919C33.3221 18.2651 33.6689 18.0331 33.9102 18.117C33.2744 18.6474 32.674 19.3284 32.363 19.7075C32.0457 20.0938 31.527 20.7793 31.1341 21.4706C31.0254 20.9338 31.7827 19.8527 32.0712 19.4842Z",
    fill: "#FFCB0A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1564 19.551C32.7862 18.7474 33.47 18.1998 33.8032 18.2076C33.2075 18.7229 32.656 19.3496 32.3628 19.7077C32.0723 20.0612 31.6134 20.6652 31.2371 21.2946C31.2758 20.9091 31.6218 20.2335 32.1564 19.551Z",
    fill: "#FEFAD6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.324 56.762L30.602 22.9744C30.5822 22.0481 31.795 20.3997 32.3628 19.7078C32.9228 19.0249 34.4219 17.3628 35.376 17.3628H42.8007C43.7544 17.3628 45.2535 19.0251 45.8133 19.7078C46.3808 20.3995 47.5944 22.0485 47.5745 22.9744L46.8526 56.762C46.7464 61.7368 31.4164 61.7783 31.324 56.762Z",
    fill: "#808184"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4319 56.7591L30.7102 22.9716C30.6799 21.5584 34.0018 17.4707 35.376 17.4707H42.8006C44.1747 17.4707 47.4963 21.5592 47.4663 22.9716L46.7446 56.7591C46.6412 61.5896 31.5219 61.6304 31.4319 56.7591Z",
    fill: "url(#paint4_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8075 18.1935C43.0518 18.2197 43.5435 18.5955 43.7397 18.7587C44.2644 19.1943 44.7396 19.7077 45.1718 20.2343C45.6009 20.7574 46.0059 21.3171 46.3355 21.909C46.4671 22.145 46.7502 22.6967 46.7449 22.9565L46.7447 22.9597L46.2635 29.3028L46.1287 29.2533C41.1983 27.4361 36.9784 27.4363 32.0481 29.2533L31.9133 29.3028L31.432 22.9595V22.9563C31.4264 22.6961 31.7095 22.1448 31.8411 21.9084C32.1708 21.3169 32.5752 20.7572 33.0048 20.2339C33.4368 19.7075 33.9122 19.1943 34.4367 18.7587C34.6329 18.5957 35.1254 18.2193 35.3693 18.1935L35.3749 18.1929H35.3807C37.8522 18.1929 40.3241 18.1929 42.7958 18.1929H42.8015L42.8075 18.1935Z",
    fill: "#A6A8AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7957 18.3013C40.324 18.3013 37.8521 18.3013 35.3807 18.3013C35.1657 18.3239 34.6669 18.7082 34.5061 18.8421C33.9915 19.2691 33.512 19.7864 33.0885 20.303C32.6668 20.8165 32.259 21.3804 31.9357 21.9613C31.8238 22.1621 31.5351 22.7216 31.5401 22.9544L32.0103 29.1517C36.9696 27.3242 41.2072 27.3242 46.1663 29.1517L46.6363 22.9544C46.6411 22.722 46.3528 22.1621 46.241 21.9615C45.9168 21.3807 45.5094 20.8167 45.0879 20.303C44.6644 19.7866 44.1845 19.2693 43.6703 18.8423C43.5095 18.7082 43.0107 18.3239 42.7957 18.3013Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.25 34.7229C32.9424 32.8284 32.6347 31.4559 32.3273 29.5616C32.2983 29.3829 32.4036 29.2123 32.5766 29.159C36.9196 27.8122 41.2625 27.7283 45.6057 29.1552C45.7757 29.2111 45.8779 29.3793 45.8493 29.556C45.5415 31.4525 45.2331 32.8266 44.9255 34.7229C44.9096 34.8219 44.8603 34.901 44.7788 34.9593C44.6971 35.0171 44.6062 35.0378 44.5074 35.0207C40.8945 34.3934 37.2812 34.3934 33.6683 35.0207C33.5697 35.0378 33.4788 35.0171 33.3971 34.9593C33.3156 34.901 33.2661 34.8219 33.25 34.7229Z",
    fill: "url(#paint6_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2502 34.7232C32.9426 32.8286 32.6351 31.4562 32.3273 29.5619C32.3104 29.4581 32.3392 29.3571 32.4001 29.2802C36.7182 27.9554 41.0363 27.8803 45.3544 29.2994C45.5244 29.3551 45.6268 29.5235 45.5979 29.7001C45.2902 31.5966 44.9822 32.9708 44.6742 34.8669C44.6645 34.9272 44.6424 34.9798 44.6084 35.025C44.5754 35.0286 44.5424 35.0272 44.5076 35.021C40.8945 34.3937 37.2812 34.3937 33.6683 35.021C33.5699 35.0381 33.4788 35.0174 33.3971 34.9596C33.3158 34.9013 33.2665 34.8222 33.2502 34.7232Z",
    fill: "url(#paint7_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2037 42.0136V42.2108C33.2037 44.2622 33.2037 46.3138 33.2037 48.3656V48.8793C33.2037 49.3601 33.2148 49.8408 33.2212 50.3216C33.2323 51.1612 33.2401 52.0515 33.1146 52.8821C33.0176 53.5271 32.8098 54.3023 32.2428 54.6947L31.8014 54.9999L31.7897 54.4637C31.7539 52.8153 31.7181 51.1673 31.6822 49.5193L31.6806 49.4412L31.7183 49.3732C31.8287 49.1736 32.0034 49.0302 32.1989 48.9137C32.0504 48.9219 31.9078 48.8931 31.7837 48.8026L31.6684 48.7187L31.6651 48.5758C31.6175 46.3818 31.5633 44.1879 31.5159 41.9939L31.514 41.9182L31.5497 41.8514C31.6291 41.7026 31.7702 41.6436 31.9372 41.6362C31.7106 41.5237 31.5328 41.3617 31.5048 41.1L31.5036 41.0879L31.5032 41.0758C31.4342 37.8991 31.3609 34.7226 31.2919 31.5459L31.2764 30.8325L31.7836 31.3343C32.2547 31.8004 32.5516 32.8891 32.6969 33.5169C33.0103 34.8715 33.147 36.3252 33.2031 37.7118L33.2035 37.7176V37.7233C33.2035 39.0325 33.2035 40.3413 33.2035 41.6504V42.0136H33.2037ZM46.2384 41.6366C46.4054 41.644 46.5469 41.703 46.6262 41.8518L46.6618 41.9186L46.66 41.9943C46.6129 44.1883 46.5584 46.3822 46.5105 48.5762L46.5073 48.7191L46.3918 48.803C46.268 48.8935 46.1254 48.9223 45.9773 48.9141C46.1725 49.0306 46.3473 49.174 46.4578 49.3736L46.4956 49.4416L46.4936 49.5197C46.4578 51.1677 46.4221 52.8157 46.3863 54.4641L46.3749 54.9999L45.9338 54.6947C45.3663 54.3021 45.1592 53.5271 45.0616 52.8821C44.9365 52.0515 44.9441 51.1612 44.9552 50.3216C44.9615 49.8408 44.9727 49.3601 44.9727 48.8793V48.3656C44.9727 46.3138 44.9727 44.2622 44.9727 42.2108V41.651C44.9727 40.3419 44.9727 39.0331 44.9727 37.7239V37.7182L44.9729 37.7124C45.0291 36.3258 45.1657 34.8721 45.4793 33.5175C45.6244 32.8899 45.9214 31.801 46.3922 31.3349L46.8998 30.8331L46.8841 31.5465C46.8151 34.7234 46.7414 37.8997 46.6728 41.0764L46.6724 41.0885L46.671 41.1006C46.6431 41.3621 46.4652 41.5239 46.2384 41.6366Z",
    fill: "url(#paint8_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9544 48.5696C31.9045 46.2735 31.8546 44.2845 31.8047 41.988C31.9142 41.7834 32.6461 42.1057 32.9149 42.2109C32.9149 44.2623 32.9149 46.3139 32.9149 48.3656C32.6415 48.4985 32.181 48.7351 31.9544 48.5696Z",
    fill: "url(#paint9_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0784 54.4576C32.0424 52.8092 32.007 51.1612 31.9712 49.5132C32.1462 49.1967 32.6468 49.0092 32.9148 48.8794C32.9148 51.0276 33.1504 53.7154 32.0784 54.4576Z",
    fill: "url(#paint10_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2222 48.5696C46.2719 46.2735 46.3218 44.2845 46.3717 41.988C46.2625 41.7834 45.5303 42.1057 45.2615 42.2109C45.2615 44.2623 45.2615 46.3139 45.2615 48.3656C45.535 48.4985 45.9951 48.7351 46.2222 48.5696Z",
    fill: "url(#paint11_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0979 54.4576C46.1337 52.8092 46.1695 51.1612 46.2053 49.5132C46.0305 49.1967 45.5297 49.0092 45.2615 48.8794C45.2615 51.0276 45.0259 53.7154 46.0979 54.4576Z",
    fill: "url(#paint12_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.384 41.0699C46.4544 37.8221 46.525 34.7881 46.5953 31.54C46.0108 32.1184 45.3983 34.3463 45.2615 37.7238C45.2615 39.0331 45.2615 40.3419 45.2615 41.6509C45.5891 41.5372 46.3452 41.435 46.384 41.0699Z",
    fill: "url(#paint13_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7924 41.0699C31.7218 37.8221 31.6512 34.7881 31.5808 31.54C32.1655 32.1184 32.7779 34.3463 32.9147 37.7238C32.9147 39.0331 32.9147 40.3419 32.9147 41.6509C32.587 41.5372 31.8315 41.435 31.7924 41.0699Z",
    fill: "url(#paint14_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9042 58.0286C32.6362 57.7801 32.6062 57.3833 32.6617 57.0407C32.7247 56.6496 32.9036 56.2504 33.1251 55.9244C33.2096 55.8009 33.3031 55.6828 33.4055 55.5736L33.6931 55.2681L33.8759 55.6458C34.1158 56.1421 35.1632 56.4538 35.6495 56.5743C36.7418 56.8453 37.9576 56.9443 39.0795 56.9513C40.203 56.9443 41.4188 56.8453 42.5111 56.5743C42.9972 56.454 44.045 56.1421 44.2847 55.6458L44.4674 55.2681L44.7549 55.5736C44.8577 55.6828 44.951 55.8009 45.0351 55.9244C45.2569 56.2506 45.4357 56.6496 45.4989 57.0407C45.5542 57.3833 45.5246 57.7801 45.2563 58.0286C44.6897 58.775 43.639 59.2068 42.7664 59.4526C41.5939 59.7826 40.3034 59.912 39.0871 59.913H39.0717C37.8564 59.9118 36.5664 59.7822 35.3942 59.4526C34.5216 59.2068 33.4707 58.775 32.9042 58.0286Z",
    fill: "#DBDCDD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0806 57.2401C36.5751 57.2245 34.0734 56.7166 33.6163 55.771C33.0077 56.4179 32.7029 57.4838 33.1179 57.8321C33.9972 59.0242 36.5338 59.6215 39.0729 59.6243H39.0806H39.0884C41.6278 59.6215 44.1636 59.0242 45.0431 57.8321C45.4585 57.4838 45.1533 56.4179 44.5447 55.771C44.0876 56.7166 41.5859 57.2245 39.0806 57.2401Z",
    fill: "url(#paint15_radial)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0159 32.6783C28.9376 32.453 28.9068 32.2061 29.0336 31.9921C29.1909 31.7269 29.5454 31.5989 29.8251 31.514C30.2025 31.3991 30.5884 31.3209 30.9631 31.1927C31.0989 31.1466 31.2325 31.0941 31.3622 31.0319L31.4558 30.9863L31.483 31.0869C31.56 31.3742 31.6367 31.6615 31.7137 31.9486L31.7359 32.0321L31.6526 32.0544C30.8085 32.2806 29.9639 32.5067 29.1199 32.7329L29.0422 32.7536L29.0159 32.6783Z",
    fill: "#A6A8AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0978 32.6506C28.699 31.5042 30.2688 31.6555 31.3999 31.1104C31.4768 31.3976 31.5536 31.6849 31.6307 31.9718C30.7861 32.1981 29.9422 32.4243 29.0978 32.6506Z",
    fill: "#F2F2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.49 32.0987L31.2161 31.0767L30.8702 31.1694L31.1441 32.1914L31.49 32.0987Z",
    fill: "#A6A8AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3844 32.0381L31.1553 31.1831L30.9763 31.2311L31.2055 32.086L31.3844 32.0381Z",
    fill: "#D1D2D3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1606 32.6783C49.2389 32.453 49.2694 32.2061 49.1425 31.9921C48.9858 31.7269 48.631 31.5989 48.3514 31.514C47.9741 31.3991 47.588 31.3209 47.2136 31.1927C47.0776 31.1466 46.9436 31.0941 46.8148 31.0319L46.7203 30.9863L46.6935 31.0869C46.6163 31.3742 46.5398 31.6615 46.4627 31.9486L46.4402 32.0321L46.5235 32.0544C47.3683 32.2806 48.2124 32.5067 49.0568 32.7329L49.1342 32.7536L49.1606 32.6783Z",
    fill: "#A6A8AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0791 32.6501C49.4777 31.5037 47.9081 31.655 46.777 31.1099C46.7001 31.3972 46.6233 31.6844 46.5464 31.9713C47.3904 32.1976 48.2347 32.4238 49.0791 32.6501Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0335 32.1904L47.3069 31.1685L46.9616 31.0761L46.6882 32.098L47.0335 32.1904Z",
    fill: "#A6A8AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9699 32.0859L47.1992 31.231L47.02 31.1829L46.7907 32.0378L46.9699 32.0859Z",
    fill: "#D1D2D3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3439 40.5857C31.3421 40.4428 31.3101 39.8438 31.4391 39.8438H31.558L31.5803 40.9798C31.4197 40.9959 31.3467 40.7742 31.3439 40.5857Z",
    fill: "#929497"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.547 40.9261C31.4126 40.9393 31.3784 40.6858 31.377 40.5856C31.375 40.4446 31.3548 39.8867 31.4404 39.8867C31.4607 39.8867 31.4766 39.8867 31.5267 39.8867C31.5337 40.2376 31.5403 40.5752 31.547 40.9261Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4917 48.1233C31.4897 47.9804 31.4579 47.3813 31.5869 47.3813H31.706L31.7281 48.5176C31.5672 48.5335 31.4941 48.3118 31.4917 48.1233Z",
    fill: "#929497"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6949 48.4645C31.5603 48.478 31.5259 48.2245 31.5249 48.1243C31.5227 47.9834 31.5024 47.4253 31.5883 47.4253C31.6084 47.4253 31.6245 47.4253 31.6746 47.4253C31.6813 47.7764 31.6879 48.114 31.6949 48.4645Z",
    fill: "url(#paint17_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8322 40.5852C46.834 40.4423 46.866 39.8433 46.737 39.8433H46.6183L46.5962 40.9793C46.7564 40.9954 46.8296 40.7737 46.8322 40.5852Z",
    fill: "#929497"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6287 40.9266C46.7635 40.9397 46.7979 40.6863 46.799 40.586C46.801 40.4451 46.8215 39.8872 46.7356 39.8872C46.7151 39.8872 46.699 39.8872 46.6489 39.8872C46.6424 40.2381 46.6356 40.5757 46.6287 40.9266Z",
    fill: "url(#paint18_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6849 48.1238C46.6867 47.9809 46.7187 47.3818 46.5896 47.3818H46.471L46.4485 48.5181C46.6091 48.534 46.6821 48.3123 46.6849 48.1238Z",
    fill: "#929497"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4822 48.4655C46.6166 48.479 46.6512 48.2255 46.6524 48.1253C46.6544 47.9843 46.6746 47.4263 46.5889 47.4263C46.5687 47.4263 46.5526 47.4263 46.5025 47.4263C46.4957 47.7774 46.4891 48.115 46.4822 48.4655Z",
    fill: "url(#paint19_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5466 55.4855C33.4676 48.8597 33.5987 38.6258 33.3096 35.3992C37.1304 34.6912 41.0465 34.6912 44.8674 35.3992C44.5779 38.6258 44.7091 48.8597 44.6306 55.4855C44.6491 57.9154 33.5275 57.9154 33.5466 55.4855Z",
    fill: "url(#paint20_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.183 54.573C34.2734 49.3093 34.1257 44.0426 33.7199 38.7947C33.7106 38.6744 33.7396 38.5593 33.8319 38.4781C33.9708 38.3563 34.171 38.3702 34.3414 38.3702C34.5637 38.3702 34.7661 38.5573 34.7572 38.7903C34.5518 44.05 34.7514 49.3244 35.22 54.5646C35.2309 54.6839 35.2037 54.7981 35.1134 54.8796C34.9747 55.0046 34.7705 54.9903 34.5989 54.9903C34.376 54.9903 34.1895 54.8054 34.183 54.578V54.5752V54.573ZM43.9936 54.578C43.987 54.8056 43.8006 54.9903 43.5777 54.9903C43.4972 54.9903 43.42 54.9943 43.3395 54.9857C43.1007 54.9609 42.9325 54.8324 42.9564 54.5648C43.4252 49.3246 43.6248 44.05 43.4196 38.7905C43.4105 38.5575 43.6129 38.3704 43.8353 38.3704C43.9155 38.3704 43.9926 38.3668 44.0729 38.3752C44.3103 38.4002 44.4771 38.5294 44.4566 38.7947C44.0507 44.0426 43.9033 49.3093 43.9938 54.573V54.5754L43.9936 54.578Z",
    fill: "#BBBDBF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2912 54.5797C34.3813 49.4027 34.2348 44.2257 33.8278 39.0487C33.8013 38.7129 34.1681 38.7487 34.3413 38.7487C34.5053 38.7487 34.6554 38.8841 34.6487 39.0487C34.4471 44.1304 34.6334 49.316 35.1123 54.5797C35.1427 54.9155 34.7716 54.8799 34.5988 54.8799C34.4342 54.8799 34.2962 54.7447 34.2912 54.5797ZM43.8855 54.5797C43.7949 49.4027 43.9416 44.2257 44.3488 39.0487C44.3752 38.7129 44.0084 38.7487 43.8354 38.7487C43.6712 38.7487 43.5213 38.8841 43.5277 39.0487C43.7297 44.1304 43.543 49.316 43.0644 54.5797C43.0338 54.9155 43.4048 54.8799 43.5778 54.8799C43.7422 54.8799 43.8804 54.7447 43.8855 54.5797Z",
    fill: "#F2F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2749 19.7163C35.4588 20.8599 35.6286 22.193 35.7634 23.6165C35.8984 25.0404 35.9813 26.3735 36.0141 27.5169C35.8304 26.3735 35.6608 25.0404 35.526 23.6165C35.3912 22.193 35.3081 20.8599 35.2749 19.7163ZM42.9009 19.7163C42.7174 20.8599 42.5476 22.193 42.4126 23.6165C42.2776 25.0404 42.1951 26.3735 42.1621 27.5169C42.346 26.3735 42.515 25.0404 42.65 23.6165C42.785 22.193 42.8681 20.8599 42.9009 19.7163Z",
    fill: "#DBDCDD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.9012,
    y1: 49.7906,
    x2: 46.9012,
    y2: 55.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31.2754,
    y1: 49.7916,
    x2: 31.2754,
    y2: 55.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 47.3615,
    y1: 24.4497,
    x2: 47.3615,
    y2: 29.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.8147,
    y1: 24.4502,
    x2: 30.8147,
    y2: 29.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 47.4663,
    y1: 38.9341,
    x2: 30.7101,
    y2: 38.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 46.6364,
    y1: 23.7264,
    x2: 31.5401,
    y2: 23.7264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5472 38.4815) scale(9.38425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5643 38.4099) scale(10.6216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 39.0883,
    y1: 43.5787,
    x2: 39.0883,
    y2: 27.0375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 32.6928,
    y1: 45.2737,
    x2: 32.0266,
    y2: 45.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 32.7714,
    y1: 51.6685,
    x2: 32.1589,
    y2: 51.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 46.1496,
    y1: 45.2737,
    x2: 45.4834,
    y2: 45.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 46.0122,
    y1: 51.6685,
    x2: 45.4326,
    y2: 51.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 46.3286,
    y1: 36.5955,
    x2: 45.5283,
    y2: 36.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 32.648,
    y1: 36.5955,
    x2: 31.8475,
    y2: 36.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9573 53.8444) scale(7.50852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 31.465,
    y1: 40.9341,
    x2: 31.4465,
    y2: 39.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 31.6129,
    y1: 48.4721,
    x2: 31.5944,
    y2: 47.4147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 46.7295,
    y1: 39.8764,
    x2: 46.711,
    y2: 40.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 46.5828,
    y1: 47.4156,
    x2: 46.5643,
    y2: 48.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 44.8672,
    y1: 46.088,
    x2: 33.3095,
    y2: 46.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkViolation);
export default __webpack_public_path__ + "static/media/park_violation.3d626b058ad5c2efddab85887d1b49cd.svg";
export { ForwardRef as ReactComponent };